<template>
  <div class="consultation-table">
    <!-- 데스크톱 뷰 -->
    <table class="desktop-view">
      <thead>
        <tr>
          <th style="width: 4%; text-align: center;">번호</th>
          <th style="width: 20%; text-align: center;">제목</th>
          <th style="width: 5%; text-align: center;">작성자</th>
          <th style="width: 4%; text-align: center;">날짜</th>
          <!-- <th style="width: 4%; text-align: center;">상태</th> -->
        </tr>
      </thead>
      <tbody>
        <tr v-for="(consultation, index) in paginatedConsultations" :key="consultation.id" @click="openConsultation(consultation.id)">
          <td style="text-align: center;">{{ calculateNumber(index) }}</td>
          <td style="padding-left: 20px;">{{ consultation.title }}</td>
          <td style="text-align: center;">{{ consultation.author }}</td>
          <td style="text-align: center;">{{ formatDate(consultation.createdAt) }}</td>
          <!-- <td style="text-align: center;">{{ consultation.status }}</td> -->
        </tr>
      </tbody>
    </table>

    <!-- 모바일 뷰 -->
    <div class="mobile-view">
      <div v-for="consultation in paginatedConsultations" :key="consultation.id" class="mobile-item" @click="openConsultation(consultation.id)">
        <h3 class="mobile-title">{{ consultation.title }}</h3>
        <div class="mobile-info">
          <span class="mobile-author">{{ consultation.author }}</span>
          <span class="mobile-date">{{ formatDate(consultation.createdAt) }}</span>
          <span v-if="isNew(consultation.createdAt)" class="mobile-new">New</span>
        </div>
      </div>
    </div>

  

    <div class="pagination">
      <button @click="changePage(currentPage - 1)" :disabled="currentPage === 1">이전</button>
      <span>{{ currentPage }} / {{ calculatedTotalPages }}</span>
      <button @click="changePage(currentPage + 1)" :disabled="currentPage === calculatedTotalPages">다음</button>
    </div>
  </div>
  
  <div class="search-wrapper">
      <div class="search-bar">
        <select v-model="searchType" class="search-type">
          <!-- <option value="all">전체</option> -->
          <option value="title">제목</option>
          <option value="author">작성자</option>
        </select>
        <input 
          v-model="searchTerm" 
          :placeholder="searchPlaceholder"
          class="search-input"
          @keyup.enter="handleSearch"
        >
        <button @click="handleSearch" class="search-button">검색</button>
      </div>
  </div>  
  
</template>

<script>
import '@/assets/css/table-style.css'

export default {
  name: 'SeedJung_ConsultingTable',
  props: {
    consultations: {
      type: Array,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    totalPages: {
      type: Number,
      required: true
    },
    totalItems: {
      type: Number,
      required: true
    },
    itemsPerPage: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      searchTerm: '',
      searchType: 'title',
      filteredData: []
    }
  },
  computed: {
    searchPlaceholder() {
      switch(this.searchType) {
        case 'title':
          return '제목을 입력하세요';
        case 'author':
          return '작성자를 입력하세요';
        default:
          return '검색어를 입력하세요';
      }
    },
    paginatedConsultations() {
      // 필터된 데이터가 있을 때만 필터된 데이터를 보여줌
      if (this.filteredData.length > 0) {
        return this.filteredData;
      }
      // 그 외의 경우 전체 데이터를 보여줌
      return this.consultations;
    },
    calculatedTotalPages() {
      if (this.filteredData.length > 0) {
        // 검색 결과가 있을 때만 필터된 결과의 길이로 계산
        const filteredLength = this.filteredData.length;
        return Math.max(1, Math.ceil(filteredLength / this.itemsPerPage));
      } else {
        // 검색 결과가 없거나 검색하지 않은 상태면 전체 페이지로 계산
        return Math.max(1, Math.ceil(this.totalItems / this.itemsPerPage));
      }
    }
  },
  methods: {
    handleSearch() {
      if (!this.searchTerm) {
        this.filteredData = [];
        return;
      }
      
      const searchLower = this.searchTerm.toLowerCase();
      
      this.filteredData = this.consultations.filter(consultation => {
        switch(this.searchType) {
          case 'title':
            return consultation.title.toLowerCase().includes(searchLower);
          case 'author':
            return consultation.author.toLowerCase().includes(searchLower);
          default: // 'all'
            return consultation.title.toLowerCase().includes(searchLower) ||
                   consultation.author.toLowerCase().includes(searchLower);
        }
      });

      // 검색 후 첫 페이지로 이동
      if (this.currentPage !== 1) {
        this.$emit('changePage', 1);
      }
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    },
    isNew(date) {
      const now = new Date();
      const consultationDate = new Date(date);
      const diffTime = Math.abs(now - consultationDate);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
      return diffDays <= 3;
    },
    changePage(newPage) {
      this.$emit('changePage', newPage);
    },
    calculateNumber(index) {
      const totalItems = this.filteredData.length > 0 ? this.filteredData.length : this.totalItems;
      return totalItems - ((this.currentPage - 1) * this.itemsPerPage + index);
    },
    openConsultation(consultationId) {
      const selectedConsultation = this.paginatedConsultations.find(item => item.id === consultationId);
      
      if (!selectedConsultation) {
        alert('해당하는 상담 데이터를 찾을 수 없습니다.');
        return;
      }
      // 관리자 계정은 모든 상담내역을 볼 수 있도록 세팅함
      if (this.$store.getters.currentUser?.username?.trim() === 'alscofld95' || 
          this.$store.getters.currentUser?.username?.trim() === selectedConsultation?.username?.trim()) {
        this.$emit('openConsultation', consultationId)
      } else {
        return;
      }
    }
  },
  watch: {
    consultations: {
      immediate: true,
      // handler(newVal) {
      //   // consultations가 변경되면 필터된 데이터 초기화
      //   this.filteredData = [];
      //   this.searchTerm = '';
      // }
      handler() {
        // consultations가 변경되면 필터된 데이터 초기화
        this.filteredData = [];
        this.searchTerm = '';
      }
    }
  }
}
</script>

<style scoped>
.consultation-table {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

.mobile-new {
  color: #ff0000;
  font-weight: bold;
}

@media (max-width: 768px) {
  .search-wrapper {
    margin: 20px 15px;
    width: auto;
  }

  .search-bar {
    width: 100%;
  }

  .search-type {
    width: 80px;
    min-width: 80px;
  }

  .search-input {
    flex: 1;
    min-width: 0;
  }

  .search-button {
    min-width: 60px;
  }
}
</style>